import { useNavigate, useLocation } from "react-router-dom";
import { Dumbbell, Play, Home, BookOpen, ClipboardList } from "lucide-react";

const GOLD = "#C9A84C";

const NAV_ITEMS = [
  { key: "mijn-schema",     icon: Dumbbell,      label: "Persoonlijk",  path: "/mijn-schema" },
  { key: "vrije-training",  icon: Play,          label: "Vrije training", path: "/vrije-training" },
  { key: "home",            icon: Home,          label: "Home",         path: "/account" },
  { key: "learn",           icon: BookOpen,      label: "Learn",        path: "/cursus" },
  { key: "schemas",         icon: ClipboardList, label: "Schema's",     path: "/account/training" },
];

export default function BottomNav() {
  const navigate  = useNavigate();
  const { pathname } = useLocation();

  const active = (() => {
    if (pathname === "/mijn-schema")                                         return "mijn-schema";
    if (pathname.startsWith("/vrije-training"))                              return "vrije-training";
    if (pathname.startsWith("/cursus"))                                      return "learn";
    if (pathname === "/account/training" || pathname.startsWith("/custom-schema") || pathname.startsWith("/schema") || pathname.startsWith("/workout") || pathname.startsWith("/hyrox")) return "schemas";
    if (pathname.startsWith("/account"))                                     return "home";
    return "";
  })();

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-white/8"
      style={{ background: "#0a0a0a", paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="bottom-nav"
    >
      <div className="flex max-w-lg mx-auto">
        {NAV_ITEMS.map(({ key, icon: Icon, label, path }) => {
          const isActive = active === key;
          return (
            <button
              key={key}
              onClick={() => navigate(path)}
              data-testid={`bottom-nav-${key}`}
              className="flex-1 flex flex-col items-center gap-1 py-3 transition-all active:scale-95"
              style={{ color: isActive ? GOLD : "#52525b" }}
            >
              <div
                className="w-7 h-7 rounded-xl flex items-center justify-center transition-all"
                style={{ background: isActive ? `${GOLD}18` : "transparent" }}
              >
                <Icon size={18} />
              </div>
              <span
                className="text-[10px] font-bold tracking-wide"
                style={{ color: isActive ? GOLD : "#52525b" }}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
